<template>
  <div>
    

    <b-row>
      <b-col md="6">
        <div class="text-left">
          <div class="mb-1">
            <b-badge pill v-if="order.status == 'Bestilling'" variant="info">
              {{ order.status }}
            </b-badge>

            <b-badge pill v-if="order.status == 'Ordre'" variant="warning">
              {{ order.status }}
            </b-badge>
            <b-badge pill v-if="order.status == 'I arbeid'" variant="primary">
              {{ order.status }}
            </b-badge>

            <b-badge pill v-if="order.status == 'Arbeid avsluttet'" variant="secondary">{{ order.status }}</b-badge>

            <b-badge pill v-if="order.status == 'Utført'" variant="success">
              {{ order.status }}
            </b-badge>

            <b-badge pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>
          </div>

          <h4 class="font-weight-bold ml-1">
            {{ order.ordernumber }} - {{ order.type }} - {{ order.supplier_company.name }}
            <span v-if="order.site.name != null">({{ order.site.name }})</span>
          </h4>
        </div>
      </b-col>

      <b-col md="6">
        <div class="text-right mt-1 mb-3">

          <b-row class="float-right mr-1">

            <b-button class="mr-2" variant="primary" @click="goBack()">Tilbake</b-button>

            <!-- <b-dropdown right split variant="primary" text="Lukk" @click="saveOrder()">
              <b-dropdown-item @click="openModalArchive()">Arkiver ordre</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="openModalData()">Vis ordre data</b-dropdown-item>
            </b-dropdown> -->

          </b-row>

        </div>
      </b-col>
    </b-row>

    <!-- Show archive modal -->

    <b-modal id="archiveModal" title="Arkiver ordre">
      Er du sikker at du ønsker å arkivere denne ordren?


      <template #modal-footer>
        <div class="w-100">

          <b-button variant="primary" class="float-right mr-2" @click="archiveOrder()">
            Arkiver
          </b-button>

          <b-button variant="default" class="float-right mr-2" @click="closeModalArchive()">
            Lukk
          </b-button>
        </div>
      </template>

    </b-modal>

    <!-- Show data modal -->

    <b-modal id="dataModal" title="Ordre data" size="xl">

      <vue-json-pretty :data="order"></vue-json-pretty>

      <template #modal-footer>
        <div class="w-100">

          <b-button variant="primary" class="float-right mr-2" @click="closeModalData()">
            Lukk
          </b-button>
        </div>
      </template>

    </b-modal>

    <!-- Main order window -->

    <b-row>

      <b-col class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="Ordre" active>
                <b-card-text>

                  <b-row>
                    <b-col md="3">

                      <!-- Edit order details   -->

                      <b-card bg-variant="light">

                        <h6>Ordre</h6>

                        <div v-if="showEditDetails == false">

                          <h5>
                            {{ order.ordernumber }} - {{ order.type }}
                          </h5>

                          Leverandør:
                          <h5>
                            {{ order.supplier_company.name }}
                          </h5>

                          Bestiller:
                          <h5>
                            {{ order.customer_company.name }}
                            <br />
                            <small class="mt-1">
                              <b-link v-b-toggle.viewCustomerDetails class="card-link">Vis detaljer</b-link>
                            </small>
                            <br />
                          </h5>

                          <b-collapse id="viewCustomerDetails" class="mt-2">

                            <div v-if="order.customer_ref">
                              Kundens referanse:
                              <h5>{{ order.customer_ref }}</h5>
                            </div>

                            <div v-if="showContacts == false">
                              Kontaktperson:
                              <h5 v-if="order.contact_name != null">
                                {{ order.contact_name }}
                                <br>
                                <small>
                                  <b-link v-if="showContacts == false" @click="editContact()" class="card-link">Endre
                                    kontaktperson</b-link>
                                  <br />

                                </small>

                              </h5>
                              <h5 v-if="order.contact_name == null" style="color: red">
                                Ingen
                                <br>
                                <small>
                                  <b-link v-if="showContacts == false" @click="editContact()" class="card-link">Endre
                                    kontaktperson</b-link>

                                </small>
                                <br />
                              </h5>
                            </div>

                            <div v-if="showContacts == true" class="mb-1">
                              Kontaktperson:
                              <b-input v-model="order.contact_name"></b-input>
                            </div>

                            <div v-if="showContacts == false">

                              <div v-if="order.contact_email1">
                                E-post:
                                <h5>{{ order.contact_email1 }}</h5>
                              </div>

                              <div v-if="order.contact_email2">
                                E-post (Alternativ):
                                <h5>{{ order.contact_email2 }}</h5>
                              </div>

                            </div>

                            <div v-if="showContacts == true" class="mb-1">
                              E-post:
                              <b-input v-model="order.contact_email1"></b-input>
                            </div>

                            <div v-if="showContacts == true" class="mb-1">
                              E-post (Alternativ):
                              <b-input v-model="order.contact_email2"></b-input>
                            </div>

                            <div v-if="showContacts == false">
                              <div v-if="order.contact_phone">
                                Telefon:
                                <h5>{{ order.contact_phone }}</h5>
                              </div>
                            </div>

                            <div v-if="showContacts == true" class="mb-1">
                              Telefon:
                              <b-input v-model="order.contact_phone"></b-input>
                            </div>

                            <b-link v-if="showContacts == true" @click="saveContact()" class="card-link mb-3">Lagre
                              kontaktperson</b-link>

                            <div v-if="order.customer_company.invoice_method == 'email'">
                              EHF faktura:
                              <h5>{{ order.customer_company.invoice_email }}</h5>
                            </div>

                            <div v-if="order.customer_company.invoice_method == 'ehf'">
                              EHF faktura:
                              <h5>{{ order.customer_company.invoice_ehf }}</h5>
                            </div>

                            <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                              Adresse:
                              <h5>{{ order.customer_company.invoice_address }}</h5>
                            </div>

                            <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                              Postnummer:
                              <h5>{{ order.customer_company.invoice_postcode }}</h5>
                            </div>

                            <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                              Poststed:
                              <h5>{{ order.customer_company.invoice_city }}</h5>
                            </div>



                            <br />
                          </b-collapse>



                          Type:
                          <h5>
                            {{ order.type }}
                          </h5>

                          Lokasjon:
                          <h5>
                            {{ order.site.name }}

                          </h5>

                          Startdatto:
                          <h5>
                            {{$date(order.startdate).format("DD.MM.YYYY")}}
                          </h5>

                          Sluttdato:
                          <h5>
                            {{$date(order.enddate).format("DD.MM.YYYY")}}
                          </h5>

                          Fartøy:
                          <h5 v-if="order.vessel != null">
                            {{ order.vessel.name }}
                          </h5>

                          Kaptein:
                          <h5 v-if="order.captain != null">
                            {{ order.captain.name }}
                          </h5>

                          Status:
                          <h5>
                            {{ order.status }}
                          </h5>

                        </div>

                      </b-card>

                    </b-col>

                    <b-col md="9">

                      <!-- Customer and contact details -->


                      <!-- Map Delousing -->
                      <div class="mb-3" v-if="order.site != null && order.type == 'Avlusning'">
                        <l-map ref="map" :zoom="4" v-bind:center="[order.site.lat, order.site.lng]"
                          style="height: 600px">
                          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                          <l-circle :lat-lng="[order.site.lat, order.site.lng]" :color="circle.color"
                            :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              {{ order.site.number }} -
                              {{ order.site.name }}
                            </l-tooltip>
                          </l-circle>

                          <l-circle v-if="order.vessel != null" :lat-lng="[order.vessel.lat, order.vessel.lng]"
                            :color="circleVessel.color" :radius="circleVessel.radius">
                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              {{ order.vessel.name}}

                            </l-tooltip>
                          </l-circle>
                        </l-map>
                      </div>

                      <!-- Map Wellboat -->

                      <div class="mb-3"
                        v-if="order.details.destination != null && order.site != null && order.type == 'Brønnbåt'">

                        <l-map ref="map" :zoom="4"
                          v-bind:center="[order.details.destination.lat, order.details.destination.lng]"
                          style="height: 585px">
                          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                          <l-circle :lat-lng="[order.site.lat, order.site.lng]" :color="circle.color"
                            :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              <span>Fra lokasjon: <br> {{ order.site.number }} - {{ order.site.name }}</span>

                            </l-tooltip>


                          </l-circle>

                          <l-circle v-if="order.vessel != null" :lat-lng="[order.vessel.lat, order.vessel.lng]"
                            :color="circleVessel.color" :radius="circleVessel.radius">
                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              {{ order.vessel.name}}

                            </l-tooltip>
                          </l-circle>


                          <l-circle :lat-lng="[order.details.destination.lat, order.details.destination.lng]"
                            :color="circle.color" :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              <span v-if="order.details.transport == 'to_location'">Til lokasjon: <br>
                                {{ order.details.destination.number }} -
                                {{ order.details.destination.name }}</span>
                              <span v-if="order.details.transport == 'to_factory'">Til slakteri: <br>
                                {{ order.details.destination.approval }} -
                                {{ order.details.destination.name }}</span>
                            </l-tooltip>


                          </l-circle>


                        </l-map>

                      </div>


                    </b-col>

                  </b-row>
                </b-card-text>
              </b-tab>

              <!-- Delousing tab   -->
              <b-tab v-if="order.type == 'Avlusning'" @click="getLicecount()" title="Avlusning">
                <b-card-text>
                  <!-- Order main windows -->

                  <b-row>

                    <!-- Order menu -->
                    <b-col md="3">

                      <b-card bg-variant="light">
                        <h6>Avlusning</h6>

                        Antall merder:
                        <h5>
                          {{ order.details.cages.length }}
                        </h5>

                        Total biomasse bestilt:
                        <h5>
                          {{
                                order.details.biomass_ordered
                                  | numeralFormat("0,0[.]00")
                              }}
                          kg
                        </h5>

                        <hr>
                        <div v-if="order.status != 'Bestilling'">
                          <h6>Utført</h6>

                          Total antall fisk:
                          <h5>
                            {{flsSumFish | numeralFormat("0,0[.]00")}}
                          </h5>

                          Total biomasse utført:
                          <h5>
                            {{order.details.biomass_total | numeralFormat("0,0[.]00 kg")}} kg
                          </h5>

                          <hr>
                        </div>


                        Notat

                        <b-form-textarea v-if="order.status == 'Bestilling'" v-model="order.details.note" class="mb-3"
                          placeholder="Notat" rows="6" max-rows="12"></b-form-textarea>

                        <h6 v-if="order.status != 'Bestilling'">{{order.details.note}}</h6>

                        <b-button v-if="order.status == 'Bestilling'" @click="saveDetails()" variant="primary">Lagre
                        </b-button>



                      </b-card>

                    </b-col>

                    <!-- Order details -->

                    <b-col>

                      <b-card>

                        <div v-if="order.status == 'Bestilling'">

                          <h6>Merder</h6>

                          <b-form inline class="mb-3">
                            <label class="sr-only">Merd nummer</label>

                            <b-form-input v-model.number="cage.from_cage" type="number" class="mb-2 mr-sm-2 mb-sm-0"
                              placeholder="Fra merdnummer"></b-form-input>

                            <b-form-input v-model.number="cage.to_cage" type="number" class="mb-2 mr-sm-2 mb-sm-0"
                              placeholder="Til merdnummer"></b-form-input>

                            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                              <b-form-input type="number" v-model.number="cage.biomass" placeholder="Biomasse (kg)">
                              </b-form-input>
                            </b-input-group>

                            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                              <b-form-input type="number" min="0" max="25" step="0.1"
                                v-model.number="cage.averageweight" placeholder="Snittvekt fisk"></b-form-input>
                            </b-input-group>

                          </b-form>

                          <b-input-group class="mb-3">

                            <b-form-input v-model.number="cage.note" id="inline-form-input-name"
                              class="mb-2 mr-sm-2 mb-sm-0" placeholder="Notat"></b-form-input>

                          </b-input-group>
                          <b-button class="mb-3" @click="addCage()" variant="primary">Legg til</b-button>
                          <br>

                          <b-table v-if="this.order.details.cages[0] != null" striped hover :fields="cageFields"
                            :items="this.order.details.cages">

                            <template v-slot:cell(cages)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

                            <template v-slot:cell(biomass)="data">{{
                        data.value | numeralFormat("0,0[.]00 kg")
                      }}
                              kg</template>

                            <template v-slot:cell(averageweight)="data">{{ data.value }} kg</template>

                            <template v-slot:cell(fishcount)="data">
                              {{ data.value | numeralFormat("0,0[.]") }}
                            </template>

                            <template v-slot:cell(actions)="data">
                              <b-button variant="primary" size="sm" @click="removeCage(data.item)">Fjern</b-button>
                            </template>

                            <br />
                          </b-table>

                        </div>


                        <!-- FLS log -->

                        <div v-if="order.status != 'Bestilling'">

                       <div class="mb-4" v-if="licecount[0] != null">

                        <h6>Lusetelling</h6>

                        <!-- Licecount table -->
                        
                        <b-table
                          show-empty
                          caption-top
                          stacked="sm"
                          :items="licecount"
                          :fields="licecountFields"
                          :tbody-tr-class="rowLicecount"
                          empty-text="There are no Licecounts to show"
                        >
                          <template v-slot:cell(week)="data">
                            <span v-if="data.item.week != null">{{ data.item.week}} - {{ data.item.year}} </span>  
                          </template>

                            <template v-slot:cell(title)="data">
                            <b-link class="link strong" :href="'#/dashboard/licecount-edit/' + data.item.id">
                              <span v-if="data.item.customer_company != null">
                                {{ data.item.customer_company.name }} <span v-if="data.item.site != null"> ({{ data.item.site.number }} - {{ data.item.site.name }})</span></span>
                            </b-link>
                          </template>  
                      
                          <template v-slot:cell(fishcount)="data">
                            <span v-if="data.item.details.fish != null">{{ data.item.details.fish.length }} </span>  
                          </template>

                          <template v-slot:cell(lice_female)="data">
                            <span v-if="data.item.details.lice_female != null">{{ data.item.details.lice_female | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(lice_moving)="data">
                            <span v-if="data.item.details.lice_moving != null">{{ data.item.details.lice_moving | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(lice_persist)="data">
                            <span v-if="data.item.details.lice_persist != null">{{ data.item.details.lice_persist | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(temperature)="data">
                            <span v-if="data.item.details.temperature_sea != null">{{ data.item.temperature_sea | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                        <template v-slot:cell(createdAt)="data">
                            {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
                          </template> 

                          <template v-slot:cell(owner)="data">
                            <span v-if="data.item.owner_username != null"> {{ data.item.owner_username }}</span>
                          </template> 

                          <template #cell(actions)="row">
                            <b-button variant="primary" class="mr-1 float-center" size="sm" @click="editLicecount(row.item.id)">
                              Åpne</b-button>
                          </template>
                    
                        </b-table>
                        
                        <hr>
                        </div>

                          <h6>Spylelogg</h6>


                          <!-- FLS data table -->

                          <b-table class="mt-3" striped hover :items="this.order.fls" :fields="flsFields"
                            :tbody-tr-class="rowCompleted" empty-text="Ingen data tilgjengelig">

                            <template v-slot:cell(regtime)="data">{{
                      $date(data.value).format("DD.MM.YYYY HH:mm")
                    }}</template>

                            <template v-slot:cell(cage)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

                            <template v-slot:cell(ejector)="data">
                              {{ data.item.data.line1_ejector }} <span v-if="data.item.lines >= 2">/</span>
                              {{ data.item.data.line2_ejector }} <span v-if="data.item.lines >= 3">/</span>
                              {{ data.item.data.line3_ejector }} <span v-if="data.item.lines >= 4">/</span>
                              {{ data.item.data.line4_ejector }}
                            </template>

                            <template v-slot:cell(flushpressure)="data">
                              {{ data.item.data.line1_flushpressure }} <span v-if="data.item.lines >= 2">/</span>
                              {{ data.item.data.line2_flushpressure }} <span v-if="data.item.lines >= 3">/</span>
                              {{ data.item.data.line3_flushpressure }} <span v-if="data.item.lines >= 4">/</span>
                              {{ data.item.data.line4_flushpressure }}
                            </template>

                            <template v-slot:cell(extrasuction)="data">
                              {{ data.item.data.line1_extrasuction }} <span v-if="data.item.lines >= 2">/</span>
                              {{ data.item.data.line2_extrasuction }} <span v-if="data.item.lines >= 3">/</span>
                              {{ data.item.data.line3_extrasuction }} <span v-if="data.item.lines >= 4">/</span>
                              {{ data.item.data.line4_extrasuction }}
                            </template>

                            <template v-slot:cell(oxygen)="data">
                              {{ data.item.data.line1_oxygen }} <span v-if="data.item.lines >= 2">/</span>
                              {{ data.item.data.line2_oxygen }} <span v-if="data.item.lines >= 3">/</span>
                              {{ data.item.data.line3_oxygen }} <span v-if="data.item.lines >= 4">/</span>
                              {{ data.item.data.line4_oxygen }}
                            </template>

                            <template v-slot:cell(fishcount)="data">{{
                      data.value | numeralFormat("0,0[.]00")
                    }}</template>


                            <template v-slot:cell(biomass)="data">{{
                      data.value | numeralFormat("0,0[.]00")
                    }} kg</template>

                            <template v-slot:cell(completed)="data">
                              <span class="dot text-centre" v-if="data.item.completed == true"></span>
                            </template>


                          </b-table>

                        </div>

                      </b-card>
                    </b-col>
                  </b-row>

                </b-card-text>
              </b-tab>

              <!-- Tab for service work -->
              <b-tab v-if="order.type == 'Servicearbeid'" title="Servicearbeid">
                <b-card-text>
                  <!-- Order details -->
                  <b-row>
                    <b-col>
                      <h5>{{ order.type }}</h5>
                      <hr />
                      <b-form-group label="Notarbeid" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group v-model="order.details.servicework" :options="serviceOptions"
                          :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <h5>Notat</h5>
                      <hr />

                      <b-form-textarea class="mt-3" id="textarea" v-model="order.details.note" placeholder="Notat"
                        rows="6" max-rows="6"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <!-- Tab for Wellboat -->
              <b-tab v-if="order.type == 'Brønnbåt'" title="Brønnbåt">

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">
                      <h6>Brønnbåt</h6>

                      <b-form-group class="mr-3 mb-3" label="Transport type">

                        <span v-if="order.details.transport == 'to_location'">Fra lokasjon til lokasjon</span>
                        <span v-if="order.details.transport == 'to_factory'">Fra lokasjon til slakteri</span>
                      </b-form-group>


                      <b-form-group class="mr-3 mb-3" label="Fra lokasjon">
                        {{order.site.number}} - {{order.site.name}}
                      </b-form-group>



                      <div class="mb-3" v-if="order.details.transport == 'to_location'">
                        <b-form-group class="mr-3 mb-3" label="Til lokasjon">
                          {{order.details.destination.number}} - {{order.details.destination.name}}
                        </b-form-group>
                      </div>


                      <div class="mb-3" v-if="order.details.transport == 'to_factory'">
                        <b-form-group class="mr-3 mb-3" label="Til slakteri">
                          {{order.details.destination.approval}} - {{order.details.destination.name}}
                        </b-form-group>
                      </div>

                      <div v-if="order.status != 'Bestilling'">

                        <b-form-group class="mr-3 mb-3" label="Fiskeslag">
                          {{order.details.species}}
                        </b-form-group>

                        <b-form-group class="mr-3 mb-3" label="Antall fisk">
                          {{order.details.fishcount}}
                        </b-form-group>


                        <b-form-group class="mr-3 mb-3" label="Notat">
                          {{order.details.note}}
                        </b-form-group>

                      </div>

                      <div v-if="order.status == 'Bestilling'">

                        <b-form-group class="mr-3 mb-3" label="Fiskeslag">
                          <b-form-select class="mr-3" v-model="order.details.species" :options="wellboatSpecies">
                          </b-form-select>
                        </b-form-group>

                        <b-form-group class="mr-3 mb-3" label="Antall fisk">
                          <b-form-input class="mr-3" type="number" v-model="order.details.fishcount"></b-form-input>

                        </b-form-group>

                        <b-form-textarea class="mt-3 mb-3" id="textarea" v-model="order.details.note"
                          placeholder="Notat" rows="6" max-rows="6"></b-form-textarea>

                        <b-button variant="primary" @click="updateOrder()">Lagre</b-button>

                      </div>

                    </b-card>
                  </b-col>

                  <b-col md="9">

                    <b-card>
                      <ul class="timeline">
                        <li class="mb-3" v-for="worklog in orderBy(order.worklogs, 'from')" :key="worklog.id">

                          <h4>{{worklog.action}} <small>({{worklog.duration}} timer)</small> </h4>
                          <h5>{{ $date(worklog.from).format("DD.MM.YYYY HH:mm")}} -
                            {{ $date(worklog.to).format("DD.MM.YYYY HH:mm")}} </h5>

                          <h6>{{worklog.description}}</h6>
                          <br>

                        </li>

                      </ul>
                    </b-card>

                  </b-col>

                </b-row>

              </b-tab>

              <!-- Tab for cage cleaning -->
              <b-tab v-if="order.type == 'Notspyling'" title="Notspyling">
                <b-card-text>

                  <b-table v-if="this.order.details.cages[0] != null" striped hover :fields="cageFields"
                    :items="this.order.details.cages">

                  </b-table>

                </b-card-text>
              </b-tab>



              <!-- Tur rapport (read-only) -->

              <b-tab v-if="order.trips && order.trips.length > 0" title="Turrapport">

                <b-table
                  :items="order.trips"
                  :fields="tripFields"
                >
                  <template v-slot:cell(tripNumber)="data">
                    {{ data.item.header && data.item.header.tripNumber }}
                  </template>

                  <template v-slot:cell(vessel)="data">
                    {{ data.item.header && data.item.header.vessel }}
                  </template>

                  <template v-slot:cell(location)="data">
                    {{ data.item.header && data.item.header.location }}
                  </template>

                  <template #cell(actions)="{ item }">
                    <b-button
                      size="md"
                      variant="primary"
                      @click="openTripPDF(item)"
                    >
                      Åpne PDF
                    </b-button>
                  </template>
                </b-table>

                <!-- Trip PDF modal (read-only) -->
                <b-modal id="tripPDFModalCustomer" size="lg" hide-footer>
                  <template #modal-title>
                    <span>Tur rapport - {{ trip.header && trip.header.tripNumber }}</span>
                  </template>

                  <vue-html2pdf
                    :show-layout="false"
                    :float-layout="false"
                    :enable-download="true"
                    :preview-modal="false"
                    :filename="`Tur ${(trip.header && trip.header.tripNumber) || ''} - ${(trip.header && trip.header.tripStart) || ''}.pdf`"
                    :manual-pagination="true"
                    pdf-format="a4"
                    pdf-content-width="100%"
                    ref="tripHtml2PdfCustomer"
                  >
                    <section slot="pdf-content" class="trip-pdf-content p-3" style="background: #fff; color: #222; font-size: 13px;">
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td colspan="4" style="font-weight:bold; font-size:18px; text-align:center; border-bottom:1px solid #333;">Eines AS - Tur rapport - {{ trip.header && trip.header.tripNumber }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Fartøy:</td>
                          <td>{{ trip.header && trip.header.vessel }}</td>
                          <td style="font-weight:bold;">Tur nr.:</td>
                          <td>{{ trip.header && trip.header.tripNumber }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Skipper:</td>
                          <td>{{ trip.header && trip.header.captain }}</td>
                          <td style="font-weight:bold;">År / uke:</td>
                          <td>{{ trip.header && trip.header.yearWeek }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Kunde:</td>
                          <td>{{ trip.header && trip.header.customer }}</td>
                          <td style="font-weight:bold;">Kontaktperson:</td>
                          <td>{{ trip.header && trip.header.customerName }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Telefon:</td>
                          <td>{{ trip.header && trip.header.customerTel }}</td>
                          <td style="font-weight:bold;">Kunde e-post:</td>
                          <td>{{ trip.header && trip.header.customerEmail }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Lokalitet:</td>
                          <td>{{ trip.header && trip.header.location }}</td>
                          <td style="font-weight:bold;">Konsesjonsnr.:</td>
                          <td>{{ trip.header && trip.header.consessionNr }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Avgangshavn:</td>
                          <td>{{ trip.header && trip.header.departurePort }}</td>
                          <td style="font-weight:bold;">Turstart:</td>
                          <td>{{ customDateFormatter(trip.header && trip.header.tripStart) }}</td>
                        </tr>
                      </table>

                      <h5 class="mt-4 mb-2">1. Lasting</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Ankomst lasteplass:</td>
                          <td>{{ customDateFormatter(trip.loading && trip.loading.arrivalDate) }} {{ trip.loading && trip.loading.arrivalTime }}</td>
                          <td style="font-weight:bold;">Lasting startet:</td>
                          <td>{{ customDateFormatter(trip.loading && trip.loading.startDate) }} {{ trip.loading && trip.loading.startTime }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Fiskeslag:</td>
                          <td>{{ trip.loading && trip.loading.species }}</td>
                          <td style="font-weight:bold;">Lasting avsluttet:</td>
                          <td>{{ customDateFormatter(trip.loading && trip.loading.endDate) }} {{ trip.loading && trip.loading.endTime }}</td>
                        </tr>
                      </table>
                      <div class="mt-2">
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                          <tr style="background:#f5f5f5; font-weight:bold;">
                            <td>Merd</td>
                            <td>Antall fisk</td>
                            <td>Snittvekt (kg)</td>
                            <td>Lasterom</td>
                            <td>Biomasse (kg)</td>
                          </tr>
                          <tr v-for="cage in trip.cages" :key="cage.number">
                            <td>{{ cage.number }}</td>
                            <td>{{ cage.fishcount }}</td>
                            <td>{{ cage.averageweight }}</td>
                            <td>{{ cage.well }}</td>
                            <td>{{ (cage.fishcount * cage.averageweight).toFixed(0) }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="mt-2">
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                          <tr>
                            <td style="font-weight:bold;">Totalt antall fisk:</td>
                            <td>{{ trip.loading && trip.loading.sumMerdsCount }}</td>
                            <td style="font-weight:bold;">Snittvekt:</td>
                            <td>{{ trip.loading && trip.loading.avgWeight }} kg</td>
                            <td style="font-weight:bold;">Biomasse:</td>
                            <td>{{ trip.loading && trip.loading.sumMerdsWeight }} kg</td>
                          </tr>
                          <tr>
                            <td style="font-weight:bold;">Fordeling BB:</td>
                            <td>{{ trip.loading && trip.loading.distributionBB }}%</td>
                            <td style="font-weight:bold;">STB:</td>
                            <td>{{ trip.loading && trip.loading.distributionSTB }}%</td>
                            <td style="font-weight:bold;">Midt:</td>
                            <td>{{ trip.loading && trip.loading.distributionMidt }}%</td>
                          </tr>
                        </table>
                      </div>
                      <div class="mt-2">
                        <b>O₂-metning avgang:</b> {{ trip.loading && trip.loading.oxygenDeparture }} %
                      </div>
                      <div class="mt-2">
                        <b>Anmerkning til lasting:</b> {{ trip.loading && trip.loading.remarksLoading }}
                      </div>

                      <h5 class="mt-4 mb-2">2. Reise</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Avreise tidspunkt:</td>
                          <td>{{ customDateFormatter(trip.travel && trip.travel.recordedDate) }} {{ trip.travel && trip.travel.recordedTime }}</td>
                          <td style="font-weight:bold;">Avlest sjøtemperatur:</td>
                          <td>{{ trip.unloading && trip.unloading.seaTemperature }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Svimere / dødfisk underveis:</td>
                          <td>{{ trip.unloading && trip.unloading.deadFishCount }}</td>
                          <td style="font-weight:bold;">Oppførsel fisk:</td>
                          <td>{{ trip.unloading && trip.unloading.fishBehaviour }}</td>
                        </tr>
                      </table>
                      <div class="mt-2">
                        <b>Anmerkning til reise:</b> {{ trip.travel && trip.travel.remarks }}
                      </div>

                      <h5 class="mt-4 mb-2">3. Lossing</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Ankomst losseplass:</td>
                          <td>{{ customDateFormatter(trip.unloading && trip.unloading.arrivalDate) }} {{ trip.unloading && trip.unloading.arrivalTime }}</td>
                          <td style="font-weight:bold;">Start lossing:</td>
                          <td>{{ customDateFormatter(trip.unloading && trip.unloading.startDate) }} {{ trip.unloading && trip.unloading.startTime }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Ferdig losset:</td>
                          <td>{{ customDateFormatter(trip.unloading && trip.unloading.endDate) }} {{ trip.unloading && trip.unloading.endTime }}</td>
                          <td style="font-weight:bold;">Dødfisk:</td>
                          <td>{{ trip.unloading && trip.unloading.deadFishCount }}</td>
                        </tr>
                      </table>
                      <div class="mt-2" v-if="trip.unloadingCages && trip.unloadingCages.length > 0">
                        <b>Lossing detaljer:</b>
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333; margin-top:8px;">
                          <tr style="background:#f5f5f5; font-weight:bold;">
                            <td>Merd</td>
                            <td>Antall fisk</td>
                            <td>Snittvekt (kg)</td>
                            <td>Biomasse (kg)</td>
                          </tr>
                          <tr v-for="cage in trip.unloadingCages" :key="cage.number">
                            <td>{{ cage.number }}</td>
                            <td>{{ cage.fishcount }}</td>
                            <td>{{ cage.averageweight }}</td>
                            <td>{{ (cage.fishcount * cage.averageweight).toFixed(0) }}</td>
                          </tr>
                        </table>
                        <div class="mt-2">
                          <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                            <tr>
                              <td style="font-weight:bold;">Totalt antall fisk:</td>
                              <td>{{ trip.unloading && trip.unloading.sumMerdsCount }}</td>
                              <td style="font-weight:bold;">Snittvekt:</td>
                              <td>{{ trip.unloading && trip.unloading.avgWeight }} kg</td>
                              <td style="font-weight:bold;">Biomasse:</td>
                              <td>{{ trip.unloading && trip.unloading.sumMerdsWeight }} kg</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="mt-2">
                        <b>Anmerkning til lossing:</b> {{ trip.unloading && trip.unloading.remarksUnloading }}
                      </div>
                      <div class="mt-4" style="font-size:11px; color:#666;">
                        Skjemaet sendes leverandør, mottaker, NFT og logistikksansvarlig så snart som mulig etter lossing og arkiveres om bord i minimum 5 år.<br>
                        NB! Enhver reklamasjon må være mottatt av rederiet innen 24 timer etter lossing. Etter denne tid har verken befrakter eller bortfrakter noe ansvar for losset last. All transport skjer på oppdretters forsikring.
                      </div>
                    </section>
                  </vue-html2pdf>

                  <div class="d-flex justify-content-between mb-3">
                    <b-button @click="downloadTripPDF()" variant="primary">Last ned</b-button>
                    <b-button @click="$bvModal.hide('tripPDFModalCustomer')" variant="secondary">Lukk</b-button>
                  </div>

                </b-modal>

              </b-tab>



              <!-- Reports -->

              <b-tab title="Rapporter">

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">

                      <h6>Rapporter</h6>
                      <b-form-checkbox v-model="report.declaration" value="true" unchecked-value="false">Egenerklæring
                      </b-form-checkbox>
                      <b-form-checkbox v-model="report.worklog" value="true" unchecked-value="false">Arbeidslogg
                      </b-form-checkbox>

                      <b-form-checkbox v-if="order.type == 'Avlusning' " v-model="report.fls" value="true"
                        unchecked-value="false">Spylelogg
                      </b-form-checkbox>

                      <b-button class="mt-3" variant="primary" @click="generateReport()">Last ned PDF</b-button>
                    </b-card>

                  </b-col>

                  <b-col md="9">
                    <b-card>

                      <vue-html2pdf :show-layout="false" :float-layout="false" :enable-download="true"
                        :preview-modal="true" :filename="
                      order.ordernumber +
                      ' - ' +
                      order.customer_company.name +
                      ' (' +
                      order.site.name +
                      ')'
                    " :manual-pagination="true" pdf-format="a4" pdf-content-width="90%" @progress="onProgress($event)"
                        @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)"
                        ref="html2Pdf">
                        <section slot="pdf-content">

                          <!-- Report header -->

                          <div class="html2pdf__page-break mt-4 pl-4">

                            <h4> {{order.type}} - {{order.customer_company.name}} ({{order.site.name}})</h4>


                            <br>

                            <b-row>
                              <b-col class="col-md-6">
                                <h5>Leverandør</h5>
                                <hr />
                                Leverandør:
                                <h5>{{ order.supplier_company.name }}</h5>

                                <div v-if="order.supplier_company.contact">
                                  Kontaktperson:
                                  <h5>{{ order.supplier_company.contact }}</h5>
                                </div>

                                <div v-if="order.supplier_company.email">
                                  E-post:
                                  <h5>{{ order.supplier_company.email }}</h5>
                                </div>

                                <div v-if="order.supplier_company.phone">
                                  Telefon:
                                  <h5>{{ order.customer_company.phone }}</h5>
                                </div>
                              </b-col>

                              <b-col class="col-md-6">
                                <h5>Bestiller</h5>
                                <hr />
                                Bestiller:
                                <h5>{{ order.customer_company.name }}</h5>

                                <div v-if="order.customer_company.contact">
                                  Kontaktperson:
                                  <h5>{{ order.customer_company.contact }}</h5>
                                </div>

                                <div v-if="order.customer_company.email">
                                  E-post:
                                  <h5>{{ order.customer_company.email }}</h5>
                                </div>

                                <div v-if="order.customer_company.phone">
                                  Telefon:
                                  <h5>{{ order.customer_company.phone }}</h5>
                                </div>
                              </b-col>


                            </b-row>




                            <b-row>

                              <b-col class="col-md-6">
                                <!-- Location and vessel information -->

                                <h5>Fartøy og lokasjon</h5>
                                <hr />

                                <b-row>
                                  <b-col v-if="order.vessel != null">
                                    Fartøy:
                                    <h5 v-if="order.vessel != null">
                                      {{ order.vessel.name }}
                                    </h5>
                                  </b-col>

                                  <b-col v-if="order.captain != null">
                                    Skipper:
                                    <h5 v-if="order.captain != null">
                                      {{ order.captain.name }}
                                    </h5>
                                  </b-col>


                                </b-row>

                                <b-row v-if="order.site != null">
                                  <b-col>
                                    Lokasjon:
                                    <h5 v-if="order.site != null">
                                      {{ order.site.number }} -
                                      {{ order.site.name }}
                                    </h5>
                                  </b-col>

                                </b-row>
                              </b-col>

                            </b-row>
                          </div>
                          <br />

                          <!-- Declarations report -->

                          <div v-if="report.declaration == true" class="html2pdf__page-break mt-4  pl-4">
                            <h5>Egenerklæring</h5>
                            <hr />

                            <h5>1. Inntaksrør, fiskepumper, silkasser, FLS-spyler
                              <br>
                              <small>Pålegges med høytrykksvasker, krypdyse,
                                innvendig i rør og pumper. Preparat Salardes
                                1,5%</small>
                            </h5>

                            <h5 v-if="order.type != 'Brønnbåt'"> 2. Lusefilter <br>
                              <small>Spyles med brannslange, legges i et kar med
                                desinfeksjon. Preparat Salardes 1,5%</small>
                            </h5>

                            <h5>{{ declarationNo(3) }}. Utvendig: Dekk, kran, stuyrehus, FLS-spyler
                              utvendig, skutesider
                              <br>
                              <small>Pålegges med høytrykksvasker. Preparat Salardes
                                1,5%</small>
                            </h5>

                            <h5>{{ declarationNo(4) }}. Løfteredskap, løftestropper, diverse løse ting
                              på dekk <br>

                              <small>Pålegges med høytrykksvasker som skum eller med
                                pumpekanne. Preparat Salardes 1,5%</small>
                            </h5>

                            <h5>{{ declarationNo(5) }}. Tauverk og fortøyningsutstyr</h5>

                            <h5>{{ declarationNo(6) }}. Innvendig: styrehus og oppholdsrom <br>
                              <small>Med bøtte og klut. Preparat Såpe</small>
                            </h5>

                            <h5>{{ declarationNo(7) }}. Arbeidstøy <br>
                              <small>Oljeklær og hansker skylles rene. Alle klær
                                vaskes i vaskemaskin på egnet program. Preparat
                                Såpe</small>
                            </h5>

                            <h5>{{ declarationNo(8) }}. Hender
                              <br>

                              <small>Håndvask. Preparat Såpe</small>
                            </h5>
                            <br>


                            <div v-if="declaration.completed_date != null">

                              Vask og desinfeksjon fullført:
                              <h6>{{ $date(declaration.completed_date).format("DD.MM.YYYY")  }}</h6>

                              Godkjent av:
                              <h6>{{declaration.accepted_by}}</h6>

                              Godkjent dato:
                              <h6>{{ $date(declaration.accepted_date).format("DD.MM.YYYY") }}</h6>
                            </div>

                          </div>


                          <!-- Worklog report -->

                          <div v-if="report.worklog == true" class="html2pdf__page-break mt-4 pl-4">
                            <h5>Arbeidslogg</h5>
                            <hr />

                            <b-table class="mt-3" small caption-bottom borderless :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="this.order.worklogs"
                              :fields="worklogsReportFields">
                              <template v-slot:cell(from)="data">{{
                            $date(data.value).format("DD.MM.YYYY HH:mm")
                          }}</template>

                              <template v-slot:cell(to)="data">{{
                            $date(data.value).format("DD.MM.YYYY HH:mm")
                          }}</template>

                              <template v-slot:cell(duration)="data">{{ data.value }} timer</template>

                              <template v-slot:table-caption>Totalt: {{ worklogSumHours }} timer</template>
                            </b-table>
                            <br />
                          </div>

                          <!-- FLS data table -->
                          <div class="html2pdf__page-break mt-4 pl-4"
                            v-if="report.fls == true && order.type == 'Avlusning'">
                            <h5>Spylelogg</h5>
                            <hr />

                            <b-table borderless small :items="this.order.fls" :fields="flsReportFields"
                              empty-text="Ingen data tilgjengelig">
                              <template v-slot:cell(regtime)="data">{{
                            $date(data.value).format("DD.MM.YYYY HH:mm")
                          }}</template>

                              <template v-slot:cell(cage)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

                              <template v-slot:cell(ejector)="data">
                                {{ data.item.data.line1_ejector }} <span v-if="data.item.lines >= 2">/</span>
                                {{ data.item.data.line2_ejector }} <span v-if="data.item.lines >= 3">/</span>
                                {{ data.item.data.line3_ejector }} <span v-if="data.item.lines >= 4">/</span>
                                {{ data.item.data.line4_ejector }}
                              </template>

                              <template v-slot:cell(flushpressure)="data">
                                {{ data.item.data.line1_flushpressure }} <span v-if="data.item.lines >= 2">/</span>
                                {{ data.item.data.line2_flushpressure }} <span v-if="data.item.lines >= 3">/</span>
                                {{ data.item.data.line3_flushpressure }} <span v-if="data.item.lines >= 4">/</span>
                                {{ data.item.data.line4_flushpressure }}
                              </template>

                              <template v-slot:cell(extrasuction)="data">
                                {{ data.item.data.line1_extrasuction }} <span v-if="data.item.lines >= 2">/</span>
                                {{ data.item.data.line2_extrasuction }} <span v-if="data.item.lines >= 3">/</span>
                                {{ data.item.data.line3_extrasuction }} <span v-if="data.item.lines >= 4">/</span>
                                {{ data.item.data.line4_extrasuction }}
                              </template>

                              <template v-slot:cell(oxygen)="data">
                                {{ data.item.data.line1_oxygen }} <span v-if="data.item.lines >= 2">/</span>
                                {{ data.item.data.line2_oxygen }} <span v-if="data.item.lines >= 3">/</span>
                                {{ data.item.data.line3_oxygen }} <span v-if="data.item.lines >= 4">/</span>
                                {{ data.item.data.line4_oxygen }}
                              </template>

                              <template v-slot:cell(fishcount)="data">{{
                            data.value | numeralFormat("0,0[.]00")
                          }}</template>


                              <template v-slot:cell(biomass)="data">{{
                            data.value | numeralFormat("0,0[.]00")
                          }}</template>
                            </b-table>
                            <br />
                          </div>
                        </section>
                      </vue-html2pdf>
                    </b-card>

                  </b-col>

                </b-row>


              </b-tab>

              <!-- Attachments -->

              <b-tab :title='"Vedlegg (" + order.attachments.length + ")"'>

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">
                      <h6>Last opp vedlegg</h6>

                      <b-form-file v-model="selectedFile" browse-text="Velg" placeholder="Ingen fil valgt"
                        drop-placeholder="Dra og slipp fil her"></b-form-file>

                      <br>
                      <b-button v-if="selectedFile == null" variant="outline-primary" disabled>Last
                        opp</b-button>
                      <b-button v-if="selectedFile != null" variant="primary" @click="onUpload()">Last opp</b-button>
                    </b-card>

                  </b-col>

                  <b-col md="9">

                    <b-card>
                      <h6>Vedlegg</h6>

                      <b-table striped hover :items="order.attachments" :fields="fieldsUpload">
                        <template v-slot:cell(name)="data">
                          <b-link :href="data.item.url" target="_blank">{{data.item.name}} </b-link>
                        </template>

                        <template v-slot:cell(size)="data">
                          {{data.item.size * 1000 | prettyBytes('MB')}}
                        </template>

                        <template v-slot:cell(createdAt)="data">
                          {{  $date(data.value).format("DD.MM.YYYY HH:mm")}}
                        </template>

                      </b-table>

                    </b-card>

                  </b-col>

                </b-row>

              </b-tab>

            </b-tabs>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from "axios";
  
  import Vue2Filters from "vue2-filters";
  import VueMoment from "vue-moment";
  import moment from "moment";
  
  import Datepicker from "vuejs-datepicker";
  import {
    debounce
  } from "lodash";
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

  import {
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LCircle,
    LPopup,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LIcon,
  } from "vue2-leaflet";

  

  import {
    Icon
  } from "leaflet";
  delete Icon.Default.prototype._getIconUrl;

  Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  export default {
    components: {
      
      LMap,
      LTileLayer,
      LMarker,
      LControlLayers,
      LControl,
      LPopup,
      LCircle,
      LPolyline,
      LLayerGroup,
      LTooltip,
      LControlZoom,
      LControlAttribution,
      LControlScale,
      LIcon,
      VueMoment,
      moment,
      
      Datepicker,
      VueTypeaheadBootstrap,
    },
    mixins: [Vue2Filters.mixin],
    data() {
      return {
        user: {},
        order: {
          agreement_type: "Avtale",
          agreement_price: 0,
          invoice_status: "Utkast",
          invoice_hours: 0,
          invoice_biomass: 0,
          invoice_total: 0,
          settings: {},
          details: {},
        },
        companies: [],
        sites: [],
        cage: {},
        fls: {
          lines: 1,
          data: {},
        },
        licecount: [],
        editfls: {},
        vessel: {
          fls: {},
        },
        worklog: {
          action: "Reise",
          duration: 0,
          rate: 0,
          total: 0,
          billable: true,
        },
        editworklog: {},
        worklogs: [],
        declaration: {
          details: {},
        },
        declarations: [],
        report: {
          fls: true,
          worklog: true,
          declaration: true,
        },
        captain: {},
        captainSelect: [],
        selectedFile: null,

        queryCompany: "",
        querySites: "",
        fls_lastupdate: null,
        fls_settingsupdate: null,
        vesselSelect: [],
        worklogDuration: 0,
        worklogDurationCal: 0,
        worklogSumHours: 0,
        worklogSumHoursBillable: 0,
        flsSumFish: 0,
        flsSumBiomass: 0,
        showEditDetails: false,
        showContacts: false,
        confirmation: false,
        sortBy: 'from',
        sortDesc: false,
        fullPage: true,
        isLoading: false,
        orderStatus: [{
            value: "Bestilling",
            text: "Bestilling",
          },
          {
            value: "Ordre",
            text: "Ordre",
          },
          {
            value: "I arbeid",
            text: "I arbeid",
          },
          {
            value: "Arbeid avsluttet",
            text: "Arbeid avsluttet",
          },
          {
            value: "Utført",
            text: "Utført",
          },
          {
            value: "Kansellert",
            text: "Kansellert",
          },
        ],
        orderType: [{
            value: "Avlusning",
            text: "Avlusning",
          },
          {
            value: "Notspyling",
            text: "Notspyling",
          },
          {
            value: "Servicearbeid",
            text: "Servicearbeid",
          },
          {
            value: "Brønnbåt",
            text: "Brønnbåt",
          },
        ],
        serviceOptions: [{
            text: "Notskifte",
            value: "Notskifte",
          },
          {
            text: "Luseskjørt fjerning/setting",
            value: "Luseskjørt fjerning/setting",
          },
          {
            text: "Fuglenett fjerning/setting",
            value: "Fuglenett fjerning/setting",
          },
          {
            text: "Lippfisk skjul",
            value: "Lippfisk skjul",
          },
          {
            text: "Fortøyningsarbeid",
            value: "Fortøyningsarbeid",
          },
          {
            text: "ROV inspeksjon",
            value: "ROV inspeksjon",
          },
          {
            text: "Annet",
            value: "Annet",
          },
        ],
        wellboatSpecies: [{
            value: "Laks - Slaktefisk",
            text: "Laks - Slaktefisk"
          },
          {
            value: "Laks - Smolt",
            text: "Laks - Smolt"
          },
          {
            value: "Laks - Stamfisk",
            text: "Laks - Stamfisk"
          },
          {
            value: "Torsk",
            text: "Torsk"
          }
        ],
        invoiceStatus: [{
            value: "Utkast",
            text: "Utkast",
          },
          {
            value: "Send til fakturering",
            text: "Send til fakturering",
          },
          {
            value: "Til fakturering",
            text: "Til fakturering",
          },
          {
            value: "Ferdig fakturert",
            text: "Ferdig fakturert",
          },
        ],
        cageFields: [{
            key: "cages",
            label: "Merder",
            sortable: true,
          },

          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: false,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "note",
            label: "Notat",
            tdClass: "notemaxwidth",
          },
          {
            key: "actions",
            label: "Handlinger",
          },
        ],
        cageFlushFields: [{
            key: "number",
            label: "Merdnummer",
            sortable: true,
          },
          {
            key: "type",
            label: "Type",
            sortable: false,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
        ],
        worklogsFields: [{
            key: "action",
            label: "Hendelse",
            sortable: true,
          },

          {
            key: "from",
            label: "Fra",
            sortable: true,
          },

          {
            key: "to",
            label: "Til",
            sortable: false,
          },
          {
            key: "duration",
            label: "Antall timer",
            sortable: false,
          },
          {
            key: "description",
            label: "Beskrivelse",
            sortable: false,
            tdClass: "worklogmaxwidth",
          },

          {
            key: "actions",
            label: "Handlinger",
            sortable: false,
          },
        ],
        worklogsInvoiceFields: [{
            key: "billable",
            label: "Fakturer",
            sortable: true,
          },
          {
            key: "action",
            label: "Hendelse",
            sortable: true,
          },
          {
            key: "description",
            label: "Beskrivelse",
            sortable: false,
            tdClass: "worklogmaxwidth",
          },

          {
            key: "duration",
            label: "Antall timer",
            sortable: false,
          },

          {
            key: "total",
            label: "Totalt",
            sortable: false,
          },

          {
            key: "actions",
            label: "Handlinger",
            sortable: false,
          },
        ],
        licecountFields: [
          { key: "week", label: "Uke", sortable: true },
          { key: "type", label: "Type", sortable: true },
          { key: "cage", label: "Merd", sortable: true },          
          { key: "fishcount", label: "Antall fisk", sortable: true },
          { key: "lice_female", label: "Hunnlus", sortable: true },
          { key: "lice_moving", label: "Bevegelige", sortable: true },
          { key: "lice_persist", label: "Fastsittende", sortable: true },
          { key: "createdAt", label: "Opprettet", sortable: true },
        ],
        worklogsReportFields: [{
            key: "action",
            label: "Hendelse",
          },

          {
            key: "from",
            label: "Fra",
          },

          {
            key: "to",
            label: "Til",
          },
          {
            key: "duration",
            label: "Antall timer",
          },
          {
            key: "description",
            label: "Beskrivelse",
            tdClass: "worklogmaxwidth",
          },
        ],
        flsReportFields: [{
            key: "regtime",
            label: "Tidspunkt",

          },
          {
            key: "cage",
            label: "Merder",

          },

          {
            key: "ejector",
            label: "Ejektor",

          },

          {
            key: "extrasuction",
            label: "Ekstra sug",

          },
          {
            key: "flushpressure",
            label: "Spyletrykk",

          },
          {
            key: "fishcount",
            label: "Antall fisk",

          },
          {
            key: "biomass",
            label: "Biomasse",

          },
          {
            key: "comment",
            label: "Kommentar",

            tdClass: "flscellmaxwidth",
          },

        ],
        flsFields: [{
            key: "regtime",
            label: "Tidspunkt",
            sortable: true,
          },
          {
            key: "cage",
            label: "Merder",
            sortable: true,
          },

          {
            key: "ejector",
            label: "Ejektor",
            sortable: true,
          },

          {
            key: "extrasuction",
            label: "Ekstra sug",
            sortable: false,
          },
          {
            key: "flushpressure",
            label: "Spyletrykk",
            sortable: false,
          },
          {
            key: "oxygen",
            label: "Oksygen",
            sortable: false,
          },

          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: false,
          },
          {
            key: "biomass",
            label: "Biomasse",
            sortable: false,
          },
          {
            key: "comment",
            label: "Kommentar",
            sortable: false,
            tdClass: "flscellmaxwidth",
          },

        ],
        worklogOptions: [{
            text: "Reise",
            value: "Reise"
          },
          {
            text: "Vent",
            value: "Vent"
          },
          {
            text: "Klargjøring",
            value: "Klargjøring",
          },
          {
            text: "Opprigg",
            value: "Opprigg",
          },
          {
            text: "Avlusning",
            value: "Avlusning",
          },
          {
            text: "Servicearbeid",
            value: "Servicearbeid",
          },
          {
            text: "Nedrigg",
            value: "Nedrigg",
          },
          {
            text: "Vasking",
            value: "Vasking",
          },
          {
            text: "Desinfeksjon",
            value: "Desinfeksjon",
          },
        ],
        billableOptions: [{
            value: true,
            text: "Fakturer"
          },
          {
            value: false,
            text: "Ikke fakturer"
          },
        ],
        optionsInvoiceAgreement: [{
            value: "Pris pr. kg",
            text: "Pris pr. kg"
          },
          {
            value: "Fastpris",
            text: "Fastpris"
          },
          {
            value: "Avtale",
            text: "Avtale"
          },
        ],
        flsLinesOptions: [{
            value: 1,
            text: "1 Linje",
          },
          {
            value: 2,
            text: "2 Linjer",
          },
          {
            value: 3,
            text: "3 Linjer",
          },
          {
            value: 4,
            text: "4 Linjer",
          },
        ],
        fieldsDeclarations: [{
            key: "ordertitle",
            label: "Ordre",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "completed_date",
            label: "Fullført",
            sortable: true
          },
          {
            key: "accepted_by",
            label: "Godkjent av",
            sortable: true
          },
          {
            key: "accepted_date",
            label: "Godkjent dato",
            sortable: true
          },
        ],
        fieldsUpload: [{
            key: "name",
            label: "Filnavn",
            sortable: true
          },
          {
            key: "size",
            label: "Størrelse",
            sortable: true
          },
          {
            key: "createdAt",
            label: "Opprettet",
            sortable: true
          },
        ],
        trip: {
          header: {},
          loading: {},
          travel: {},
          unloading: {},
          cages: [],
          unloadingCages: [],
          signatures: {},
        },
        tripFields: [
          { key: 'tripNumber', label: 'Tur nr.' },
          { key: 'vessel', label: 'Fartøy' },
          { key: 'location', label: 'Lokasjon' },
          { key: 'loading.startDate', label: 'Start lasting' },
          { key: 'unloading.endDate', label: 'Avsluttet lossing' },
          { key: 'actions', label: '' },
        ],
        speciesOptions: [
          { value: 'Laks', text: 'Laks' },
          { value: 'Ørret', text: 'Ørret' },
          { value: 'Torsk', text: 'Torsk' },
          { value: 'Annet', text: 'Annet' },
        ],
        zoom: 10,
        url: "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
        attribution: '<a href="https://www.aquaservices.no">Aquaservices.no</a> ',
        circle: {
          radius: 2,
          color: "#022D56",
        },

        circleVessel: {
          radius: 1,
          color: "#025D46",
        },
        max: 5,
      };
    },
    // A prop is a custom attribute for passing information to a component
    props: ["id"],

    // Check if user is logged in
    computed: {
      isLoggedIn: function () {
        return this.$store.getters.isLoggedIn;
      },
    },
    // We use computed properties based on 'props' to avoid any complex logic in our template
    watch: {
      // whenever question changes, this function will run
      vessel: function () {
        this.order.vessel = this.vessel;
      },
      captain: function () {
        this.order.captain = this.captain;
      },
      worklog: function () {
        this.worklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.worklog.startdate + ", " + this.worklog.fromtime
        ).locale("no");

        var end = moment(
          this.worklog.enddate + ", " + this.worklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        this.worklog.duration = durationWorklogCal;
      },
    },
    methods: {
      // Brønnbåt has no lice filter, so the Egenerklæring skips item 2 and renumbers the rest.
      declarationNo(n) {
        return this.order.type == 'Brønnbåt' && n > 2 ? n - 1 : n;
      },
      getUser() {
        axios
          .get("https://api.eines-as.no/users/me")
          .then((res) => {
            this.user = res.data;
            if (this.declaration.accepted_by == null) {
              this.declaration.accepted_by = this.user.username;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getOrder() {
        this.isLoading = true;
        axios
          .get(`https://api.eines-as.no/orders/${this.id}`)

          .then((response) => {
            this.order = response.data;
            this.isLoading = false;

            // Set Invoice rate
            if (this.order.supplier_company.invoice_rate != null) {
              this.worklog.rate = this.order.supplier_company.invoice_rate;
            }

            // Set FLS settings
            if (this.order.fls.length > 0) {
              const copyflsSettings = this.order.fls.slice(-1)[0];

              const flsSettings = JSON.parse(JSON.stringify(copyflsSettings));

              this.fls = flsSettings;
            }

            // Set declaration
            if (this.order.declarations.length > 0) {
              this.declaration = this.order.declarations.slice(-1)[0];
            }

            // Calculate biomass ordered
            if (this.order.details.cages[0] != null) {
              this.order.details.biomass_ordered = this.order.details.cages.reduce(
                (n, {
                  biomass
                }) => n + biomass,
                0
              );
            }

            if (this.order.details.cages[0] == null) {
              this.order.details.biomass_ordered = 0;
            }

            // Calculate worklog total hours

            if (this.order.worklogs[0] != null) {
              this.worklogSumHours = this.order.worklogs.reduce(
                (n, {
                  duration
                }) => n + duration,
                0
              );
            }

            // Calculate worklog total billable hours

            if (this.order.worklogs[0] != null) {
              this.worklogSumHoursBillable = this.order.worklogs
                .filter(({
                  billable
                }) => billable == true)
                .reduce((n, {
                  duration
                }) => n + duration, 0);
            }

            // Calculate worklog total to invoice
            if (this.order.worklogs[0] != null) {
              this.order.invoice_hours = this.order.worklogs
                .filter(({
                  billable
                }) => billable == true)
                .reduce((n, {
                  total
                }) => n + total, 0);

              this.order.invoice_total =
                this.order.invoice_hours +
                this.order.invoice_biomass;
            }

            // Calculate total fish count and biomass

            if (this.order.fls[0] != null) {
              this.flsSumFish = this.order.fls
                .filter(({
                  completed
                }) => completed == true)
                .reduce((n, {
                  fishcount
                }) => n + fishcount, 0);

              this.flsSumBiomass = this.order.fls
                .filter(({
                  completed
                }) => completed == true)
                .reduce((n, {
                  biomass
                }) => n + biomass, 0);

              this.order.details.biomass_total = this.flsSumBiomass
            }

            this.getVessels();
            this.getCaptain();
          });
      },

      updateOrder() {
        this.isLoading = true;
        this.showEditDetails = false;

        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;
          var message = {
            to: this.order.contact_email1,
            cc: this.order.contact_email2,
            subject: "Ordrebekreftelse - " +
              this.order.supplier_company.name +
              " - " +
              this.order.ordernumber,
            text: "Dette er en ordrebekreftelse fra " +
              this.order.supplier_company.name +
              " med ordrenummer " +
              this.order.ordernumber,
          };

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {
              this.order.send_confirmation = false;
            })
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Send inovice notification

        if (this.order.invoice_status == "Send til fakturering") {
          this.order.invoice_status = "Til fakturering";

          var message = {
            to: this.order.supplier_company.invoice_accountant,
            subject: "Ordre er klar til fakturering - " + this.order.ordernumber,
            text: "Ordrenummer " +
              this.order.ordernumber +
              " er klar til fakturering.",
          };

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Update order
        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.order = response.data;
            this.isLoading = false;

            // Set Invoice rate
            if (this.order.supplier_company.invoice_rate != null) {
              this.worklog.rate = this.order.supplier_company.invoice_rate;
            }

            // Set FLS settings
            if (this.order.fls.length > 0) {
              const copyflsSettings = this.order.fls.slice(-1)[0];

              const flsSettings = JSON.parse(JSON.stringify(copyflsSettings));

              this.fls = flsSettings;
            }

            // Set declaration
            if (this.order.declarations.length > 0) {
              this.declaration = this.order.declarations[0];
            }

            // Calculate biomass ordered
            if (this.order.details.cages[0] != null) {
              this.order.details.biomass_ordered = this.order.details.cages.reduce(
                (n, {
                  biomass
                }) => n + biomass,
                0
              );
            }

            if (this.order.details.cages[0] == null) {
              this.order.details.biomass_ordered = 0;
            }

            // Calculate total fish count and biomass
            if (this.order.fls[0] != null) {
              this.flsSumFish = this.order.fls
                .filter(({
                  completed
                }) => completed == true)
                .reduce((n, {
                  fishcount
                }) => n + fishcount, 0);

              this.flsSumBiomass = this.order.fls
                .filter(({
                  completed
                }) => completed == true)
                .reduce((n, {
                  biomass
                }) => n + biomass, 0);

              this.order.details.biomass_total = this.flsSumBiomass

            }

            // Calculate worklog total hours
            if (this.order.worklogs[0] != null) {
              this.worklogSumHours = this.order.worklogs.reduce(
                (n, {
                  duration
                }) => n + duration,
                0
              );
            }

            // Calculate worklog total billable hours
            if (this.order.worklogs[0] != null) {
              this.worklogSumHoursBillable = this.order.worklogs
                .filter(({
                  billable
                }) => billable == true)
                .reduce((n, {
                  duration
                }) => n + duration, 0);
            }

            // Calculate worklog total to invoice
            if (this.order.worklogs[0] != null) {
              this.order.invoice_hours = this.order.worklogs
                .filter(({
                  billable
                }) => billable == true)
                .reduce((n, {
                  total
                }) => n + total, 0);

              this.order.invoice_total =
                this.order.invoice_hours +
                this.order.invoice_biomass
            }
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      saveOrder() {
        this.isLoading = true;

        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;

          var message = {
            to: this.order.contact_email1,
            cc: this.order.contact_email2,
            subject: "Ordrebekreftelse - " +
              this.order.supplier_company.name +
              " - " +
              this.order.ordernumber,
            text: "Dette er en ordrebekreftelse fra " +
              this.order.supplier_company.name +
              " med ordrenummer " +
              this.order.ordernumber,
          };

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Send inovice notification

        if (this.order.invoice_status == "Send til fakturering") {
          this.order.invoice_status = "Til fakturering";

          var message = {
            to: this.order.supplier_company.invoice_accountant,
            subject: "Ordre er klar til fakturering - " + this.order.ordernumber,
            text: "Ordrenummer " +
              this.order.ordernumber +
              " er klar til fakturering.",
          };

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Save order and go back to orders

        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.isLoading = false;
            this.$router.push("/dashboard/orders");
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      getLicecount() {
      this.isLoading = true;

      axios
        .get("https://api.eines-as.no/licecounts?_sort=createdAt:DESC&_where[order]=" + this.order.id)
        .then((res) => {
          this.licecount = res.data; 
          this.isLoading = false;
        });
      },
      archiveOrder() {
        this.isLoading = true;

        this.order.archived = true

        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.isLoading = false;
            this.$router.push("/dashboard/orders");
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });

      },

      getVessels() {
        var company = localStorage.getItem("company");

        axios
          .get("https://api.eines-as.no/vessels?_where[company]=" + company)
          .then((response) => {
            var vesselSelect = [];
            var vesselDataArray = response.data;

            vesselDataArray.forEach((data) => {
              var vesselObject = {
                value: data,
                text: data.name,
              };
              vesselSelect.push(vesselObject);
            });

            this.vesselSelect = vesselSelect;
          });
      },
      getCaptain() {
        var company = localStorage.getItem("company");

        axios
          .get("https://api.eines-as.no/crews?_where[company]=" + company)
          .then((response) => {
            var captainSelect = [];
            var captainData = response.data;

            captainData.forEach((data) => {
              var captainObject = {
                value: data,
                text: data.name,
              };
              captainSelect.push(captainObject);
            });
            this.captainSelect = captainSelect;
          });
      },

      saveWorklog() {
        this.isLoading = true;

        var worklogData = {
          action: this.worklog.action,
          billable: this.worklog.billable,
          rate: this.worklog.rate,
          total: this.worklog.total,
          from: moment(
            this.worklog.startdate + ", " + this.worklog.fromtime
          ).locale("no"),
          to: moment(this.worklog.enddate + ", " + this.worklog.totime).locale(
            "no"
          ),
          duration: this.worklog.duration,
          description: this.worklog.description,
          order: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
        };

        axios
          .post("https://api.eines-as.no/worklogs/", worklogData)
          .then((response) => {
            this.order.worklogs.push(response.data);

            this.updateOrder();
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      updateWorklog() {
        var UpdateWorklogData = {
          action: this.editworklog.action,
          billable: this.editworklog.billable,
          rate: this.editworklog.rate,
          total: this.editworklog.total,
          from: moment(
            this.editworklog.startdate + ", " + this.editworklog.fromtime
          ).locale("no"),
          to: moment(
            this.editworklog.enddate + ", " + this.editworklog.totime
          ).locale("no"),
          duration: this.editworklog.duration,
          description: this.editworklog.description,
          order: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
        };

        axios
          .put(
            "https://api.eines-as.no/worklogs/" + this.editworklog.id,
            UpdateWorklogData
          )
          .then(() => {
            this.$bvModal.hide("editWorklogModal");

            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      deleteWorklog() {
        this.order.invoice_hours =
          this.order.invoice_hours - this.editworklog.total;

        this.calculateInvoice();

        axios
          .delete("https://api.eines-as.no/worklogs/" + this.editworklog.id)
          .then(() => {
            this.$bvModal.hide("editWorklogModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      saveFLS() {
        this.isLoading = true;

        this.fls_lastupdate = new Date();
        this.fls_settingsupdate = new Date();

        var flsData = {
          order: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          vessel: this.order.vessel.name,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
          lat: this.fls.lat,
          lng: this.fls.lng,
          lines: this.fls.lines,
          from_cage: this.fls.from_cage,
          to_cage: this.fls.to_cage,
          regtime: new Date(),
          comment: this.fls.comment,
          temperature_air: this.fls.temperature_air,
          temperature_sea: this.fls.temperature_sea,
          fishcount: this.fls.fishcount,
          biomass: this.fls.biomass,
          completed: this.fls.completed,
          data: {
            line1_ejector: this.fls.data.line1_ejector,
            line2_ejector: this.fls.data.line2_ejector,
            line3_ejector: this.fls.data.line3_ejector,
            line4_ejector: this.fls.data.line4_ejector,
            line1_extrasuction: this.fls.data.line1_extrasuction,
            line2_extrasuction: this.fls.data.line2_extrasuction,
            line3_extrasuction: this.fls.data.line3_extrasuction,
            line4_extrasuction: this.fls.data.line4_extrasuction,
            line1_flushpressure: this.fls.data.line1_flushpressure,
            line2_flushpressure: this.fls.data.line2_flushpressure,
            line3_flushpressure: this.fls.data.line3_flushpressure,
            line4_flushpressure: this.fls.data.line4_flushpressure,
            line1_oxygen: this.fls.data.line1_oxygen,
            line2_oxygen: this.fls.data.line2_oxygen,
            line3_oxygen: this.fls.data.line3_oxygen,
            line4_oxygen: this.fls.data.line4_oxygen,
          },
        };

        axios
          .post("https://api.eines-as.no/fls/", flsData)
          .then((response) => {
            this.order.fls.push(response.data);
            this.isLoading = false;
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      updateFLS() {
        axios
          .put("https://api.eines-as.no/fls/" + this.editfls.id, this.editfls)
          .then(() => {
            this.$bvModal.hide("editFLSModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      deleteFLS() {
        axios
          .delete("https://api.eines-as.no/fls/" + this.editfls.id)
          .then(() => {
            this.$bvModal.hide("editFLSModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      saveDeclaration() {
        this.isLoading = true;

        var declarationData = {
          orderid: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          vessel: this.order.vessel.name,
          maintenance_date: this.order.vessel.maintenance_date,
          maintenance_site: this.order.vessel.maintenance_site,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
          details: this.declaration.details,
          accepted_date: this.declaration.accepted_date,
          completed_date: this.declaration.completed_date,
          accepted_by: this.declaration.accepted_by,
          note: this.declaration.note,
        };

        axios
          .post("https://api.eines-as.no/declarations/", declarationData)
          .then((response) => {
            this.order.declarations.push(response.data);
            this.updateOrder();
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      onUpload() {
        this.isLoading = true;
        let formData = new FormData()

        formData.append('ref', 'orders');
        formData.append('path', 'orders/' + this.order.id);
        formData.append('refId', this.order.id);
        formData.append('field', 'attachments');
        formData.append("files", this.selectedFile, this.selectedFile.name);

        let optionsUpload = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

        axios.post('https://api.eines-as.no/upload', formData, optionsUpload, )
          .then((response) => {
            this.selectedFile = null
            this.getOrder()
            this.isLoading = false;
          })

      },
      onFileChanged(event) {
        this.selectedFile = event.target.files[0]
      },
      addCage() {
        this.cage.fishcount = this.cage.biomass / this.cage.averageweight;
        this.order.details.cages.push(this.cage);
        this.cage = {};
        this.updateOrder();
      },
      removeCage(cage) {
        let index = this.order.details.cages.indexOf(cage);
        this.order.details.cages.splice(index, 1);
        this.updateOrder();
      },

      generateReport() {
        this.isLoading = true;
        this.$refs.html2Pdf.generatePdf();
        this.isLoading = false;
      },
      editWorklogModal(worklog) {
        this.editworklog = worklog;
        this.editworklog.startdate = moment(worklog.from).format("YYYY-MM-DD");

        this.editworklog.enddate = moment(worklog.to).format("YYYY-MM-DD");

        this.editworklog.fromtime = moment(worklog.from).format("HH:mm");

        this.editworklog.totime = moment(worklog.to).format("HH:mm");
        this.$bvModal.show("editWorklogModal");
      },
      closeWorklogModal() {
        this.$bvModal.hide("editWorklogModal");
      },
      editFLSModal(fls) {
        this.editfls = fls;
        this.$bvModal.show("editFLSModal");
      },
      closeFLSModal() {
        this.$bvModal.hide("editFLSModal");
      },
      openModalArchive() {
        this.$bvModal.show("archiveModal");
      },
      closeModalArchive() {
        this.$bvModal.hide("archiveModal");
      },
      openModalData() {
        this.$bvModal.show("dataModal");
      },
      closeModalData() {
        this.$bvModal.hide("dataModal");
      },

      getFLSsettings() {
        this.fls = this.order.settings;
      },
      saveFLSsettings() {
        this.order.settings = this.fls;
        this.updateOrder();
      },
      saveLog(logdata) {
        this.isLoading = true;

        var logData = {
          type: "FLS",
          data: logdata,
          from: order.company_supplier.id,
        };

        axios
          .post("https://api.eines-as.no/logs/", logData)
          .then((response) => {
            this.order.worklogs.push(response.data);
            this.updateOrder();
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      changeWorklogAction(action) {
        this.worklog.rate = action.rate;
        this.worklog.billable = action.billable;
        this.calculateWorklogDuration();
      },
      changeEditWorklogAction(action) {
        this.editworklog.rate = action.rate;
        this.editworklog.billable = action.billable;
        this.calculateEditWorklogDuration();
      },
      calculateWorklogDuration() {
        this.worklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.worklog.startdate + ", " + this.worklog.fromtime
        ).locale("no");

        var end = moment(
          this.worklog.enddate + ", " + this.worklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        this.worklog.duration = durationWorklogCal;

        this.worklog.total = this.worklog.duration * this.worklog.rate;
      },
      calculateEditWorklogDuration() {
        this.editworklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.editworklog.startdate + ", " + this.editworklog.fromtime
        ).locale("no");

        var end = moment(
          this.editworklog.enddate + ", " + this.editworklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        this.editworklog.duration = durationWorklogCal;

        this.editworklog.total =
          this.editworklog.duration * this.editworklog.rate;
      },
      calculateInvoice() {
        this.showEditDetails = false;
        this.$forceUpdate();

        // Calculate worklog total billable hours

        if (this.order.worklogs[0] != null) {
          this.worklogSumHoursBillable = this.order.worklogs
            .filter(({
              billable
            }) => billable == true)
            .reduce((n, {
              duration
            }) => n + duration, 0);
        }

        if (this.order.agreement_type == "Pris pr. kg") {
          this.order.invoice_biomass =
            this.order.details.biomass_total * this.order.agreement_price;

          this.order.invoice_total =
            this.order.invoice_hours + this.order.invoice_biomass;
        }

        if (
          this.order.agreement_type == "Avtale" ||
          this.order.agreement_type == "Fastpris"
        ) {
          this.order.invoice_total =
            this.order.invoice_hours + this.order.invoice_biomass;
        }
      },
      lookupCompanies: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(
            `https://api.eines-as.no/companies?_where[type]=Customer&_q=${this.queryCompany}`
          )
          .then((response) => {
            this.companies = response.data;
          });
      }, 250),
      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      externalLink(url) {
        window.open(url, "_blank");
      },
      goExternalPage() {
        window.open(
          "https://www.ordertracker.com/sscc/" +
          this.order.sscc +
          "?number=" +
          this.order.number +
          "&type=1",
          "_blank"
        );
      },
      editContact() {
        this.showContacts = true;
      },
      saveContact() {
        this.showContacts = false;
        this.updateOrder();
      },
      editDetails() {
        this.showEditDetails = true;
      },
      saveDetails() {
        this.calculateInvoice();

        this.updateOrder();
      },
      rowLicecount(item, type) {
        if (!item || type !== "row") return;
        if (item.type == "Ut telling") return "table-success";
      },
      rowCompleted(item, type) {
        if (!item || type !== "row") return;
        if (item.completed == true) return "table-success";
      },
      refreshMap() {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      },

      customFormatter(date) {
        return moment(date).format("DD.MM.YYYY");
      },

      getDates() {
        this.worklog.startdate = moment().format("YYYY-MM-DD");
        this.worklog.enddate = moment().format("YYYY-MM-DD");
        this.worklog.fromtime = moment().format("HH:mm");
        this.worklog.totime = moment().format("HH:mm");
        this.declaration.accepted_date = new Date();
        this.declaration.completed_date = new Date();
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() + 5);

        this.disabledDates = {
          to: new Date(),
        };
      },
      goBack() {
        this.$router.push("/customer/orders");
      },
      refreshMap() {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 0);
      },
      openTripPDF(trip) {
        this.trip = trip;
        this.$bvModal.show('tripPDFModalCustomer');
      },
      downloadTripPDF() {
        this.$refs.tripHtml2PdfCustomer.generatePdf();
      },
      customDateFormatter(date) {
        return date ? moment(date).format('DD.MM.YYYY') : '';
      },
    },
    created: function () {

      this.getOrder();

    },
  };

</script>

<style lang="css">
  @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";

  .overflow-hidden {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .flscellmaxwidth {
    max-width: 250px;
  }

  .worklogmaxwidth {
    max-width: 300px;
  }

  .notemaxwidth {
    max-width: 300px;
  }

  .h-scroll {
    height: 80vh;
    /* %-height of the viewport */
    overflow: auto;
  }

  .dot {
    text-align: center;
    height: 7px;
    width: 7px;
    background-color: #801529;
    border-radius: 50%;
    display: inline-block;
  }

  label {
    display: block;
    width: x;
    height: y;
    text-align: left;
  }

  .table .table-success,
  .table .table-success>th,
  .table .table-success>td {
    background-color: #e4fae9;
  }

  @media (min-width: 576px) {
    .card-columns {
      column-count: 1;
    }

    .card-columns-nomap {
      column-count: 1 !important;
    }
  }

  @media (min-width: 768px) {
    .card-columns {
      column-count: 1;
    }

    .card-columns-nomap {
      column-count: 1 !important;
    }
  }

  @media (min-width: 1024px) {
    .card-columns {
      column-count: 2;
    }

    .card-columns-nomap {
      column-count: 2 !important;
    }
  }

  @media (min-width: 1250px) {
    .card-columns {
      column-count: 2;
    }

    .card-columns-nomap {
      column-count: 2 !important;
    }
  }

</style>
